// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_1030","text":"_14472","icon":"_15764"};